import type { TKeycloakEnv } from './keycloak.types'

export const REALMS: Record<TKeycloakEnv, string> = {
  local: 'insights_dev',
  test: 'insights_dev',
  development: 'insights_dev',
  staging: 'insights_prod',
  production: 'insights_prod',
}

export const CLIENT_IDS: Record<TKeycloakEnv, string> = {
  local: 'insights-test-env',
  test: 'insights-test-env',
  development: 'insights-dev',
  staging: 'insights-stag',
  production: 'insights-prod',
}

export const ENDPOINT: Record<TKeycloakEnv, string> = {
  local: 'https://login.dev.insights.winnin.com/auth/',
  test: 'https://login.dev.insights.winnin.com/auth/',
  development: 'https://login.dev.insights.winnin.com/auth/',
  staging: 'https://login-insights.winnin.com/auth/',
  production: 'https://login-insights.winnin.com/auth/',
}
